
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comment/my/[[...pathParams]]",
      function () {
        return require("private-next-pages/comment/my/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comment/my/[[...pathParams]]"])
      });
    }
  